import React from "react";
import { useLsp } from "../store/LspContext";

export default function Homeloan() {
    const { state } = useLsp();
    return (
        <>
            <div style={card}>
                <h2 style={{ marginTop: 0 }}>How to test (flow)</h2>
                <ol>
                    <li>Go to <b>1) Token</b> → generate token</li>
                    <li>Go to <b>2) Create Loan</b> → it returns <b>loan_id</b> (use it as <b>partner_loan_id</b>)</li>
                    <li>Then test other pages using that Partner Loan ID</li>
                </ol>

                <div style={{ marginTop: 10, opacity: 0.8 }}>
                    Current Base URL: <code>{state.baseUrl}</code><br />
                    {/* Tip: Use Sandbox or Production base URL from PDF. :contentReference[oaicite:14]{index = 14} */}
                </div>
            </div>
        </>
    );
}

const card = { padding: 16, border: "1px solid #334155", borderRadius: 12, background: "" };
